import reducer from './reducers';

export { default as viewActions } from './actions';
export { default as viewTypes } from './types';

export default reducer;
